import axios from '@axios'

const group = 'report/'
const route = 'team/salary_summary'

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {

    index(context, { itemsPerPage, page, filters }) {
      return axios.post(`${group + route}?page=${page}&items_per_page=${itemsPerPage}`, filters)
    },

    getExportExcel(constext, data) {
      return axios.post(`${group + route}/export_excel`, data, { responseType: 'blob' })
    },

    getExportPdf(constext, data) {
      return axios.post(`${group + route}/export_pdf`, data, { responseType: 'blob' })
    },

  },

}
